import { render } from "./DonorScholarshipFeedBack.vue?vue&type=template&id=426b9d30&scoped=true"
import script from "./DonorScholarshipFeedBack.vue?vue&type=script&lang=js"
export * from "./DonorScholarshipFeedBack.vue?vue&type=script&lang=js"

import "./DonorScholarshipFeedBack.vue?vue&type=style&index=0&id=426b9d30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-426b9d30"

export default script